(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/poker-twister-button/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_actions/poker-twister-button/assets/javascripts/init.js');
"use strict";


const _svs$components$poker = svs.components.poker.common.util,
  startPokerTwister = _svs$components$poker.startPokerTwister,
  launchTwisterFromStorage = _svs$components$poker.launchTwisterFromStorage;
const handleClick = node => {
  const _node$dataset = node.dataset,
    gamecodename = _node$dataset.gamecodename,
    trackingString = _node$dataset.trackingString;
  if (trackingString) {
    svs.components.analytics.trackEvent({
      category: 'Poker',
      action: 'initiate poker twister',
      opt_label: trackingString
    });
  }
  if (gamecodename) {
    startPokerTwister(gamecodename);
  }
};
const setupEventListener = () => {
  const nodes = document.querySelectorAll('.js-banner-actions-poker-twister');
  nodes.forEach(node => {
    node.addEventListener('click', () => {
      handleClick(node);
    });
  });
};
const init = () => {
  setupEventListener();
  launchTwisterFromStorage();
};
init();

 })(window);